export var CutPlane;
(function (CutPlane) {
    CutPlane[CutPlane["Bottom"] = 0] = "Bottom";
    CutPlane[CutPlane["Top"] = 1] = "Top";
    CutPlane[CutPlane["Left"] = 2] = "Left";
    CutPlane[CutPlane["Right"] = 3] = "Right";
})(CutPlane || (CutPlane = {}));
export const getSimpleBoard = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/getSimpleBoard', params);
        },
    };
};
